import UI from '../../components/ExcerciseTypes/Design/UserInterface';
import D1 from '../../components/ExcerciseTypes/Design/TypeIn';


const json = {
  1: {
    unit: 'Unit 4 ',
    id: 'SB4-U4-P31-E1',
    audio: 'img/FriendsPlus/Page30/Audio/audio-e2-p30.mp3',
    video: 'Videos/e2.p30.mp4',
    component: UI,
    // exerciseKey: '',
    recorder: true,
    isAllowSubmit: false,
    questionImage: [ // Row
      [
        { url: 'img/FriendsPlus/Page31/E1/1.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page30/E2/4.jpg', audioUrl: 'img/FriendsPlus/Page30/Audio/hinh1-e2-p30.mp3' },
        { url: 'img/FriendsPlus/Page30/E2/5.jpg', audioUrl: 'img/FriendsPlus/Page30/Audio/hinh2-e2-p30.mp3' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page30/E2/6.jpg', audioUrl: 'img/FriendsPlus/Page30/Audio/hinh3-e2-p30.mp3' },
        { url: 'img/FriendsPlus/Page30/E2/7.jpg', audioUrl: 'img/FriendsPlus/Page30/Audio/hinh4-e2-p30.mp3' },
      ],
    ],
  },
  2: {
    unit: 'Unit 4 ',
    id: 'SB4-U4-P31-E2',
    audio: 'img/FriendsPlus/Page31/Audio/audio-e2-p31.mp3',
    video: '',
    component: UI,
    // exerciseKey: '',
    recorder: true,
    isAllowSubmit: false,
    questionImage: [ // Row
      [
        // Column1
        { url: 'img/FriendsPlus/Page31/E2/1.jpg' },
        { url: 'img/FriendsPlus/Page31/E2/2.jpg', audioUrl: 'img/FriendsPlus/Page31/Audio/tieude-e2-p31.mp3' },
        { url: 'img/FriendsPlus/Page31/E2/3.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page31/E2/4.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page31/E2/5.jpg' },
        { url: 'img/FriendsPlus/Page31/E2/6.jpg', audioUrl: 'img/FriendsPlus/Page31/Audio/doan1.mp3' },
        { url: 'img/FriendsPlus/Page31/E2/7.jpg' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page31/E2/8.jpg' },
        { url: 'img/FriendsPlus/Page31/E2/9.jpg', audioUrl: 'img/FriendsPlus/Page31/Audio/doan2.mp3' },
        { url: 'img/FriendsPlus/Page31/E2/10.jpg' },
      ],
      [
        // Column5
        { url: 'img/FriendsPlus/Page31/E2/11.jpg' },
        { url: 'img/FriendsPlus/Page31/E2/12.jpg', audioUrl: 'img/FriendsPlus/Page31/Audio/doan3.mp3' },
        { url: 'img/FriendsPlus/Page31/E2/13.jpg' },
      ],
      [
        // Column6
        { url: 'img/FriendsPlus/Page31/E2/14.jpg' },
      ],

    ],
  },
  3: { // Exercise num
    unit: 'Unit 4 ',
    id: 'SB4-U4-P31-E3',
    audio: '',
    video: '',
    component: D1,
    padding: 0,
    textAlign: 'center',
    maxLength: 1,
    exerciseKey: 'img/FriendsPlus/Page31/E3/Key/answerKey.png',
    question: [
    ],
    questionImage: [
      [
        // Column1
        { url: 'img/FriendsPlus/Page31/E3/1.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page31/E3/2.jpg' },
        { url: 'img/FriendsPlus/Page31/E3/3.jpg', input: true, answer: "2" },
        { url: 'img/FriendsPlus/Page31/E3/4.jpg' },
        { url: 'img/FriendsPlus/Page31/E3/5.jpg', input: true, answer: "3" },
        { url: 'img/FriendsPlus/Page31/E3/6.jpg' },
        { url: 'img/FriendsPlus/Page31/E3/7.jpg', input: true, answer: "5" },
        { url: 'img/FriendsPlus/Page31/E3/8.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page31/E3/9.jpg' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page31/E3/10.jpg' },
        { url: 'img/FriendsPlus/Page31/E3/11.jpg', input: true, answer: "4" },
        { url: 'img/FriendsPlus/Page31/E3/12.jpg' },
      ],
      [
        // Column5
        { url: 'img/FriendsPlus/Page31/E3/13.jpg' },
      ],

    ]
  },
  4: { // Exercise num
    unit: 'Unit 4 ',
    id: 'SB4-U4-P31-E4',
    audio: '',
    video: '',
    component: D1,
    padding: 0,
    exerciseKey: 'img/FriendsPlus/Page31/E4/Key/answerKey.png',
    question: [
    ],
    questionImage: [
      [
        // Column1
        { url: 'img/FriendsPlus/Page31/E4/1.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page31/E4/2.jpg' },
        { url: 'img/FriendsPlus/Page31/E4/3.jpg', input: true, answer: "'re" },
        { url: 'img/FriendsPlus/Page31/E4/4.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page31/E4/5.jpg' },
        { url: 'img/FriendsPlus/Page31/E4/6.jpg', input: true, answer: "aren't" },
        { url: 'img/FriendsPlus/Page31/E4/7.jpg' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page31/E4/8.jpg' },
      ],
      [
        // Column5
        { url: 'img/FriendsPlus/Page31/E4/9.jpg' },
        { url: 'img/FriendsPlus/Page31/E4/10.jpg', input: true, answer: "aren't" },
        { url: 'img/FriendsPlus/Page31/E4/11.jpg' },
        { url: 'img/FriendsPlus/Page31/E4/12.jpg', input: true, answer: "isn't" },
        { url: 'img/FriendsPlus/Page31/E4/13.jpg' },
      ],
      [
        // Column6
        { url: 'img/FriendsPlus/Page31/E4/14.jpg' },
        { url: 'img/FriendsPlus/Page31/E4/15.jpg', input: true, answer: "'re" },
        { url: 'img/FriendsPlus/Page31/E4/16.jpg' },
        { url: 'img/FriendsPlus/Page31/E4/17.jpg', input: true, answer: "'s" },
        { url: 'img/FriendsPlus/Page31/E4/18.jpg' },
      ],


    ]
  },
  5: {
    unit: 'Unit 4 ',
    id: 'SB4-U4-P31-E5',
    audio: '',
    video: '',
    component: UI,
    // exerciseKey: '',
    recorder: true,
    isAllowSubmit: false,
    questionImage: [ // Row
      [
        // Column1
        { url: 'img/FriendsPlus/Page31/E5/1.jpg' },
      ],
    ],
  },
}

export default json;